/*
 * @Author: cc
 * @LastEditTime: 2025-09-04 14:27:58
 */

import { LeftOutlined } from "@ant-design/icons";
import { Button, Input, Modal, message } from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { post } from "../../common/fetch";
import { useQuery } from "../../common/utils";
import defaultDoctor from "../../img/default_teacher.jpg";
import "./play.scss";
const { TextArea } = Input;
interface teacherProps {
  // 讲师姓名
  name: string;
  // 讲师头像
  avatar: string;
  // 工作单位
  employer: string;
  // 讲师简介
  desc: string;
}
interface courseListProps {
  // 课程名称
  title: string;
  // 播放链接
  url: string;
  // 视频时长
  durationText: string;
  // 讲师信息
  teacher: teacherProps;
  // 观看状态
  userStatus: number;
  // 0:需要考试 1:先不要
  ignoreExam: number;
  // id
  id: string;
  // 考试类型
  examType: number;
}
export default function Play() {
  const query = useQuery();
  const classId = query.get("classId");
  const projectId = query.get("projectId");
  const [courseList, setCourseList] = useState<courseListProps[]>([]);
  const [refToken, setRefToken] = useState("");
  const [courseListIndex, setCourseListIndex] = useState(0);
  const [teacher, setTeacher] = useState({} as teacherProps);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [content, setContent] = useState("");
  const [isIframeLoading, setIsIframeLoading] = useState(false);
  const history = useHistory();
  const iframeRef = useRef<HTMLIFrameElement>(null);
  /**
   * 获取课程详情
   */
  const getSectionInfo = useCallback(async () => {
    try {
      const {
        data: { courseList, refToken },
      } = await post(
        `/shop/front/cm/train/class/${classId}/project/${projectId}/info`,
        {},
        false
      );
      setCourseList(courseList);
      setTeacher(courseList[0]?.teacher || {});
      setRefToken(refToken);

      // 使用ref而不是getElementById来操作iframe
      if (iframeRef.current && courseList[0]) {
        setIsIframeLoading(true);
        iframeRef.current.src = `${courseList[0].url}&refToken=${refToken}`;
      }
    } catch (error) {
      message.error("获取课程信息失败");
      console.error("获取课程详情失败:", error);
    }
  }, [classId, projectId]);

  useEffect(() => {
    getSectionInfo();
  }, [getSectionInfo]);
  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const addNotes = useCallback(async () => {
    if (!content.trim()) {
      message.info("笔记不能为空");
      return;
    }

    if (content.length > 1000) {
      message.info("笔记最多为1000字");
      return;
    }

    try {
      const param = {
        classId,
        projectId,
        courseId: courseList[courseListIndex].id,
        content,
      };

      await post(`/shop/front/cm/train/user/learn/note/add`, param, false);
      message.success("提交成功");
      handleCancel();
    } catch (error) {
      message.error("提交失败，请重试");
      console.error("添加笔记失败:", error);
    }
  }, [content, classId, projectId, courseList, courseListIndex]);
  const onChange = useCallback(({ target: { value } }: any) => {
    setContent(value);
  }, []);

  // 切换课程的优化函数
  const switchCourse = useCallback(
    (index: number) => {
      if (index === courseListIndex || !courseList[index]) return;

      setIsIframeLoading(true);
      setCourseListIndex(index);
      setTeacher(courseList[index].teacher || {});

      if (iframeRef.current && refToken) {
        iframeRef.current.src = `${courseList[index].url}&refToken=${refToken}`;
      }
    },
    [courseListIndex, courseList, refToken]
  );

  // iframe加载完成处理
  const handleIframeLoad = useCallback(() => {
    setIsIframeLoading(false);
  }, []);
  return (
    <>
      <div className="video_title">
        <p
          className="left"
          onClick={() => {
            history.go(-1);
          }}
        >
          <LeftOutlined />
        </p>
        <p
          style={{ fontSize: "20px" }}
          onClick={() => {
            history.push("/person");
          }}
        >
          个人中心
        </p>
      </div>
      <div className="playInfo_box">
        <div className="video_info">
          <div style={{ paddingBottom: "60px", overflowY: "scroll" }}>
            <div
              className="project_name_box"
              style={{
                background: "#999999",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                fontSize: "16px",
                color: "#fff",
                height: "42px",
                lineHeight: "42px",
              }}
            >
              课件列表
            </div>
            {courseList.map((item, index) => {
              return (
                <p className="show-info" onClick={() => switchCourse(index)}>
                  <div className="course_item">
                    <p
                      className={
                        index === courseListIndex
                          ? "check course_title"
                          : "course_title"
                      }
                    >
                      {item.title}
                    </p>
                    {item.teacher && <p>主讲老师：{item.teacher.name}</p>}
                    <div className="course_exam_status">
                      <p>时长：{item.durationText}</p>
                      {item.userStatus === 3 && (
                        <div className="finish_icon pass">已通过</div>
                      )}
                    </div>
                  </div>
                </p>
              );
            })}
          </div>
        </div>
        <div id="aliLivePlayer" style={{ position: "relative" }}>
          {isIframeLoading && (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 10,
                background: "transparent",
                padding: "20px",
                borderRadius: "4px",
              }}
            >
              加载中...
            </div>
          )}
          <iframe
            ref={iframeRef}
            title="播放"
            allowFullScreen
            onLoad={handleIframeLoad}
            style={{
              width: "100%",
              height: "calc(100vh - 53px)",
              border: "none",
              // display: isIframeLoading ? "none" : "block",
            }}
          />
        </div>
        <div className="video_info">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%",
            }}
          >
            <div
              style={{
                overflowY: "scroll",
              }}
            >
              <div
                style={{
                  background: "#999999",
                  color: "#fff",
                  fontSize: "16px",
                  height: "42px",
                  lineHeight: "42px",
                  padding: "0 10px",
                }}
              >
                讲师介绍
              </div>
              <div className="teacher_info">
                <div>
                  <img
                    style={{
                      width: "60px",
                      height: "60px",
                      borderRadius: "50%",
                    }}
                    src={teacher.avatar || defaultDoctor}
                    alt=""
                  />
                </div>
                <div style={{ marginLeft: "20px", fontSize: "16px" }}>
                  <div>{teacher.name || "暂无介绍"}</div>
                  <div>{teacher.employer || ""}</div>
                </div>
              </div>
              <div style={{ padding: "10px 8px" }}>
                <div>{teacher.desc}</div>
              </div>
            </div>
            {courseList[courseListIndex] && (
              <div style={{ display: "flex" }}>
                {courseList[courseListIndex].ignoreExam === 0 &&
                  courseList[courseListIndex].userStatus === 3 && (
                    <Button
                      size="large"
                      block
                      style={{
                        background: "#a6a6a6",
                        color: "#ffff",
                      }}
                    >
                      考试通过
                    </Button>
                  )}
                {courseList[courseListIndex].userStatus === 2 &&
                  courseList[courseListIndex].ignoreExam === 0 && (
                    <Button
                      block
                      disabled={courseList[courseListIndex].userStatus !== 2}
                      size="large"
                      onClick={() => {
                        history.push(
                          `/exam?partnerClassId=${classId}&examType=${3}&projectId=${projectId}&courseId=${
                            courseList[courseListIndex].id
                          }`
                        );
                      }}
                      style={{
                        background: "#537fd6",
                        color: "#ffff",
                      }}
                    >
                      开始考试
                    </Button>
                  )}
                {courseList[courseListIndex].ignoreExam === 0 &&
                  [0, 1].includes(courseList[courseListIndex].userStatus) && (
                    <Button block disabled size="large">
                      开始考试
                    </Button>
                  )}
                <Button
                  block
                  type="primary"
                  size="large"
                  onClick={() => {
                    setContent("");
                    setIsModalVisible(true);
                  }}
                >
                  笔记
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
      <Modal
        title="笔记"
        footer={null}
        closable={true}
        open={isModalVisible}
        className="notesModal"
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <TextArea
          value={content}
          placeholder=""
          onChange={onChange}
          showCount
          maxLength={1000}
          autoSize={true}
          className="notes_modal"
          style={{ height: 300 }}
        />
        <div style={{ textAlign: "right", padding: "40px 0 20px" }}>
          <Button
            type="primary"
            onClick={addNotes}
            style={{ cursor: "pointer" }}
          >
            提交
          </Button>
        </div>
      </Modal>
    </>
  );
}
